import moment from 'moment';
import timeTrackingModel from '$$timeTrackingModel';
import timeParser from '$$helpers/timeParser';
import dateHelper from '$$dateFormatsHelper';

export const TIME_LOG_TOOLTIP_MAX_WIDTH = 234;
export const TIME_LOG_TOOLTIP_MAX_HEIGHT = 200;

export function getLogsWithComments(ganttId, taskId) {
  if (!ganttId || !taskId) {
    return [];
  }

  const data = timeTrackingModel.getLogsByParamsNotCopy(ganttId, taskId);

  if (!data?.logs?.length) {
    return [];
  }

  return data.logs
    .filter(log => log.comment?.trim())
    .sort((a, b) => new Date(a.date) - new Date(b.date));
}

export function formatTimeLogTooltipEntries(ganttId, taskId, limit = null) {
  const logs = getLogsWithComments(ganttId, taskId);
  const formatDate = webix.Date.dateToStr(dateHelper.getDateFormat());
  const visibleLogs = limit == null ? logs : logs.slice(0, limit);

  return visibleLogs.map(log => ({
    id: log.id,
    meta: `${formatDate(moment(log.date).toDate()).trim()}, ${timeParser.output(log.time, {})}`,
    comment: log.comment.trim(),
  }));
}

export function findListViewCellElement(cellId) {
  if (cellId == null || cellId === '') {
    return null;
  }

  const id = String(cellId);
  const cells = document.querySelectorAll('[data-list-view-cell]');

  for (const el of cells) {
    if (el.getAttribute('data-list-view-cell') === id) {
      return el;
    }
  }

  return null;
}

export function getTimeLogListViewCellPosition(anchorElement, cellId = null) {
  const cellEl = findListViewCellElement(cellId)
    || anchorElement?.closest?.('[data-list-view-cell]')
    || anchorElement;

  if (!cellEl) {
    return null;
  }

  const rect = cellEl.getBoundingClientRect();

  return {
    x: rect.left,
    y: rect.top,
    left: rect.left,
    right: rect.right,
    bottom: rect.bottom,
    width: rect.width,
  };
}

let pendingTimeLogPopupOpen = null;

export function setPendingTimeLogPopupOpen(options) {
  pendingTimeLogPopupOpen = options;
}

export function consumePendingTimeLogPopupOpen() {
  const options = pendingTimeLogPopupOpen;

  pendingTimeLogPopupOpen = null;

  return options;
}
